<a
  [routerLink]="isSplitting ? null : ['/app', 'meetings', call.id]"
  [queryParams]="{ isSearchOpen: null }"
  queryParamsHandling="merge"
  [class.splitting]="isSplitting"
  [matTooltip]="isSplitting ? ('CALLS.SPLITTING_IN_PROGRESS' | translate) : ''"
  matTooltipShowDelay="0"
>
  <div class="panel" [class.active]="isActive" [class.compact]="useCompactMode">
    <div class="row main">
      <div class="thumbnail">
        <img
          [ngSrc]="call.thumbnailUrl !== null ? call.thumbnailUrl : './assets/images/thumbnail-placeholder.png'"
          onerror="this.src = './assets/images/thumbnail-placeholder.png'"
          alt=""
          width="100"
          height="70"
        />
      </div>
      <div class="right-container">
        <div class="details">
          <div class="title">{{ call.name }}</div>
          <div class="counterparty-names" [matTooltip]="!useCompactMode ? formattedCounterpartyNames : ''">{{ formattedCounterpartyNames }}</div>
          <div class="footer">
            @if (call.isPrevious && call.processingStatus) {
              @if (isSplitting) {
                <mat-chip class="small-chip processing-status-chip">{{ 'CALLS.PROCESSING_STATUSES.SPLITTING_CALL' | translate }}</mat-chip>
              } @else {
                <mat-chip class="small-chip processing-status-chip">{{ 'CALLS.PROCESSING_STATUSES.' + call.processingStatus | translate }}</mat-chip>
              }
            }
            <span
              [matTooltip]="
                !useCompactMode
                  ? (call.date | date: 'd MMM y') + ' · ' + (call.date | date: 'HH:mm') + (call.duration ? ' · ' + (call.duration | duration) + 's' : '')
                  : ''
              "
            >
              {{ call.date | date: 'd MMM y' }} · {{ call.date | date: 'HH:mm' }}{{ call.duration ? ' · ' + (call.duration | duration) + 's' : '' }}
            </span>
            @if (call.accessLevel === 'VIEWER') {
              <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.VIEWER' | translate">visibility</mat-icon>
            } @else if (call.accessLevel === 'COMMENTER') {
              <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.COMMENTER' | translate">comment</mat-icon>
            } @else if (call.accessLevel === 'EDITOR') {
              <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.EDITOR' | translate">edit_note</mat-icon>
            }
          </div>
        </div>
        @if (!useCompactMode) {
          <div class="menu-container">
            <div class="top-row">
              @if (!call.isPostProcessingComplete) {
                <button mat-icon-button (click)="toggleNotificationSetting($event)">
                  @if (call.notifyWhenPostProcessingCompletes) {
                    <mat-icon [matTooltip]="'CALLS.NOTIFICATIONS.DONT_NOTIFY_ME' | translate">notifications_active</mat-icon>
                  } @else {
                    <mat-icon [matTooltip]="'CALLS.NOTIFICATIONS.NOTIFY_ME' | translate">notifications</mat-icon>
                  }
                </button>
              }
              @if (call.callSetIndex !== null && call.callSetSize !== null && call.callSetSize > 1) {
                <div class="part-badge" [matTooltip]="'CALLS.PART_BADGE_TOOLTIP' | translate: { index: call.callSetIndex + 1, total: call.callSetSize }">
                  {{ 'CALLS.PART_BADGE_TEXT' | translate: { index: call.callSetIndex + 1, total: call.callSetSize } }}
                </div>
              }
            </div>
            @if (!isSplitting) {
              <div class="menu">
                <button mat-icon-button (click)="onMenuClick($event)" [matMenuTriggerFor]="menu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item translate="COMMON.DELETE" (click)="delete(call)"></button>
                </mat-menu>
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (call.matches !== undefined && call.matches.length > 0) {
      <div class="row matches">
        @for (match of call.matches; track match.speakerId) {
          <div
            class="match"
            [matTooltip]="match.sentence"
            [class.active]="activeMatch === match.sentenceSearchId"
            [style.left.%]="getMatchLeft(call, match.startTimeSeconds)"
          ></div>
        }
      </div>
    }
  </div>
</a>
